import TicketLogTitle from 'modules/emergencies/components/log/logComponents/TicketLogTitle';
import QuoteLogTitle from 'modules/emergencies/components/log/logComponents/QuoteLogTitle';
import AssignedLogTitle from 'modules/emergencies/components/log/logComponents/AssignedLogTitle';
import ArrowRight from 'assets/icons/xpo/status_icons/arrow-rigth.svg';
import DolarCircle from 'assets/icons/xpo/status_icons/dollar-circle.svg';
import MessageCircle from 'assets/icons/xpo/status_icons/message-circle.svg';
import MessageCircleRed from 'assets/icons/xpo/status_icons/message-circle-red.svg';
import CheckGreen from 'assets/icons/xpo/status_icons/check-circle-1 2.svg';
import CheckWarning from 'assets/icons/xpo/status_icons/check-circle-yellow-1 2.svg';
import CheckEmpty from 'assets/icons/xpo/status_icons/check-circle-1-alternate 2.svg';
import Exclamation from 'assets/icons/xpo/status_icons/girded-exclamation.svg';
import ExclamationRed from 'assets/icons/xpo/status_icons/girded-exclamation-red.svg';
import InfoBlue from 'assets/icons/xpo/status_icons/girded-info-blue.svg';
import InfoGray from 'assets/icons/xpo/status_icons/girded-info.svg';
import Cancel from 'assets/icons/xpo/status_icons/log-type.svg';
import Avatar from 'assets/icons/xpo/status_icons/single-neutral-circle 1.svg';
import NewComment from 'assets/icons/xpo/status_icons/new-comment.svg';
import Log from 'assets/icons/xpo/status_icons/task-list-text-1 1.svg';
import LOG_VERBS from 'modules/emergencies/components/log/logConstants';
import TicketMovedLogTitle from './logComponents/TicketMovedLogTitle';
import NotificationFailedLogTitle from './logComponents/NotificationFailedLogTitle';
import TicketUpdateLogTitle from './logComponents/TicketUpdateLogTitle';
import TicketLogTitleCarrier from './logComponents/TicketLogTitleCarrier';

const t = {
  ticket_assigned: 'Ticket assigned',
  ticket_cancelled: 'Ticket cancelled',
  ticket_created: 'Ticket created',
  ticket_edited: 'Ticket edited',
  ticket_moved: 'Ticket sent to TMS, awaiting response',
  quote_accepted: 'Quote accepted',
  quote_rejected: 'Quote rejected',
  quote_expired: 'Quote expired',
  quote_edited: 'Quote edited',
  quote_sent: 'Quote sent',
  cancellation: 'Cancellation reasons',
  rejection: 'Rejection reasons',
  interest_revalidated: 'The customer remains interested in the service',
  error_sending_message: 'Error sending the message',
  carrier_reply: 'Carrier reply',
  auctionRejected: 'Offer rejected',
  auctionStarted: 'Offer published',
  auctionClosed: 'Cost negotiation finished',
  commented: 'New comment',
  integration_status_updated: 'Integration status updated',
};

const config = (config) => {
  const VERB_CONSTANTS = config ? config : LOG_VERBS;
  const logConfig = {
    [VERB_CONSTANTS.ASSIGNED]: {
      render: (props) => <AssignedLogTitle {...props} icon={Avatar} title={t.ticket_assigned} />,
    },
    [VERB_CONSTANTS.CANCELLED]: {
      render: (props) => <TicketLogTitle {...props} icon={Cancel} title={t.ticket_cancelled} />,
    },
    [VERB_CONSTANTS.CREATED]: {
      render: (props) => <TicketLogTitle {...props} icon={Log} title={t.ticket_created} />,
    },
    [VERB_CONSTANTS.EDITED]: {
      render: (props) => <TicketLogTitle {...props} icon={InfoGray} title={t.ticket_edited} />,
    },
    [VERB_CONSTANTS.DONE]: {
      render: (props) => (
        <TicketMovedLogTitle {...props} icon={CheckWarning} title={t.ticket_moved} />
      ),
    },
    [VERB_CONSTANTS.QUOTE_ACCEPTED]: {
      render: (props) => <QuoteLogTitle {...props} icon={CheckEmpty} title={t.quote_accepted} />,
    },
    [VERB_CONSTANTS.QUOTE_EXPIRED]: {
      render: (props) => <QuoteLogTitle {...props} icon={Exclamation} title={t.quote_expired} />,
    },
    [VERB_CONSTANTS.QUOTE_REJECTED]: {
      render: (props) => <QuoteLogTitle {...props} icon={Cancel} title={t.quote_rejected} />,
    },
    [VERB_CONSTANTS.QUOTE_SENT]: {
      render: (props) => <QuoteLogTitle {...props} icon={ArrowRight} title={t.quote_sent} />,
    },
    [VERB_CONSTANTS.QUOTE_DETAILS_PROVIDED]: {
      render: (props) => <QuoteLogTitle {...props} icon={InfoGray} title={t.quote_edited} />,
    },
    [VERB_CONSTANTS.QUOTE_FEEDBACK_PROVIDED]: {
      render: (props) => <TicketLogTitle {...props} icon={InfoBlue} title={t.rejection} />,
    },
    [VERB_CONSTANTS.FEEDBACK_PROVIDED]: {
      render: (props) => <TicketLogTitle {...props} icon={InfoBlue} title={t.cancellation} />,
    },
    [VERB_CONSTANTS.USER_INTEREST_REVALIDATED]: {
      render: (props) => (
        <TicketLogTitle {...props} icon={InfoBlue} title={t.interest_revalidated} />
      ),
    },
    [VERB_CONSTANTS.QUOTE_ADDED]: {
      render: (props) => <QuoteLogTitle {...props} icon={ArrowRight} title={t.quote_sent} />,
    },
    [VERB_CONSTANTS.NOTIFICATION_SEND_FAILED]: {
      render: (props) => (
        <NotificationFailedLogTitle
          {...props}
          icon={ExclamationRed}
          title={t.error_sending_message}
        />
      ),
    },
    [VERB_CONSTANTS.QUOTE_NOTIFICATION_SEND_FAILED]: {
      render: (props) => (
        <NotificationFailedLogTitle
          {...props}
          icon={ExclamationRed}
          title={t.error_sending_message}
        />
      ),
    },
    [VERB_CONSTANTS.DELIVERED]: {
      render: (props) => (
        <TicketUpdateLogTitle {...props} icon={InfoBlue} type={VERB_CONSTANTS.DELIVERED} />
      ),
    },
    [VERB_CONSTANTS.DELAYED]: {
      render: (props) => (
        <TicketUpdateLogTitle {...props} icon={InfoBlue} type={VERB_CONSTANTS.DELAYED} />
      ),
    },
    [VERB_CONSTANTS.ON_THE_WAY]: {
      render: (props) => (
        <TicketUpdateLogTitle {...props} icon={InfoBlue} type={VERB_CONSTANTS.ON_THE_WAY} />
      ),
    },
    [VERB_CONSTANTS.PICKUP]: {
      render: (props) => (
        <TicketUpdateLogTitle {...props} icon={InfoBlue} type={VERB_CONSTANTS.PICKUP} />
      ),
    },
    [VERB_CONSTANTS.TICKET_BID_RECEIVED]: {
      render: (props) => (
        <TicketLogTitle {...props} hasSubtitle={true} icon={DolarCircle} title={t.carrier_reply} />
      ),
    },
    [VERB_CONSTANTS.AUCTION_REJECTED]: {
      render: (props) => (
        <TicketLogTitleCarrier {...props} icon={MessageCircleRed} title={t.auctionRejected} />
      ),
    },
    [VERB_CONSTANTS.AUCTION_STARTED]: {
      render: (props) => (
        <TicketLogTitleCarrier {...props} icon={MessageCircle} title={t.auctionStarted} />
      ),
    },
    [VERB_CONSTANTS.AUCTION_CLOSED]: {
      render: (props) => (
        <TicketLogTitleCarrier {...props} icon={MessageCircle} title={t.auctionClosed} />
      ),
    },
    [VERB_CONSTANTS.COMMENTED]: {
      render: (props) => <TicketLogTitle {...props} icon={NewComment} title={t.commented} />,
    },
    [VERB_CONSTANTS.INTEGRATION_STATUS_UPDATE]: {
      render: (props) => {
        const icon = !props.titleData?.log?.action_object?.data?.external_order_code
          ? InfoBlue
          : CheckGreen;
        return <TicketLogTitle {...props} icon={icon} title={t.integration_status_updated} />;
      },
    },
  };
  return logConfig;
};

export default config;
